(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-add-notification"] && !Shopify.designMode) return;
  try {
    class CartAddNotification extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;
      this._timer = null;
      this._image = this.querySelector('[data-cart-add-image]');
      this._placeholder = this.querySelector('[data-cart-add-placeholder]');
      this._heading = this.querySelector('[data-cart-add-heading]');
      this._title = this.querySelector('[data-cart-add-title]');
      this.querySelector('[data-cart-add-close]')?.addEventListener('click', () => this.hide());
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !this.hasAttribute('hidden')) this.hide();
      });
    }

    show({ image, title } = {}) {
      if (this._heading) {
        this._heading.textContent = this.dataset.msg || 'Item added to your cart';
      }
      if (this._title) this._title.textContent = title || '';

      if (image && this._image) {
        this._image.src = image;
        this._image.alt = title || '';
        this._image.hidden = false;
        if (this._placeholder) this._placeholder.hidden = true;
      } else if (this._image) {
        this._image.removeAttribute('src');
        this._image.hidden = true;
        if (this._placeholder) this._placeholder.hidden = false;
      }

      this.hidden = false;
      clearTimeout(this._timer);
      this._timer = setTimeout(() => this.hide(), 5000);
    }

    hide() {
      this.hidden = true;
      clearTimeout(this._timer);
      this._timer = null;
    }
  }

  if (!customElements.get('cart-add-notification')) {
    customElements.define('cart-add-notification', CartAddNotification);
  }

  window.__cartAddNotification = {
    show(opts) {
      const el = document.querySelector('cart-add-notification');
      if (el && typeof el.show === 'function') el.show(opts);
    },
    hide() {
      const el = document.querySelector('cart-add-notification');
      if (el && typeof el.hide === 'function') el.hide();
    },
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-search"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-search]').forEach((search) => {
    const input = search.querySelector('[data-search-input]');
    const form = search.querySelector('.search__form');
    const defaultState = search.querySelector('[data-search-default]');
    const results = search.querySelector('[data-search-results]');
    const sideHeading = search.querySelector('[data-side-heading]');
    const sidePills = search.querySelector('[data-side-pills]');
    const predictiveUrl = form.dataset.predictiveUrl;
    const suggestJsonUrl = predictiveUrl.endsWith('.json') ? predictiveUrl : `${predictiveUrl}.json`;
    const header = search.closest('.header');
    const suggestLabel = search.dataset.suggestLabel;
    const trendingLabel = search.dataset.trendingLabel || sideHeading.textContent;
    const fallbackPills = sidePills.innerHTML;
    let trendingPillsHtml = fallbackPills;
    let trendingLoaded = false;

    let seeds = [];
    try {
      seeds = JSON.parse(search.dataset.trendingSeeds || '[]').filter(Boolean);
    } catch (e) {
      seeds = [];
    }

    let timer;
    let controller;

    const positionPanel = () => {
      if (header) {
        search.style.setProperty(
          '--search-panel-top',
          `${Math.round(header.getBoundingClientRect().bottom)}px`
        );
      }
    };

    const escapeHtml = (value) =>
      String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');

    const renderPills = (items) => {
      if (!items.length) return fallbackPills;
      return items
        .map((item) => {
          const href = item.url || `${window.Shopify?.routes?.root || '/'}search?q=${encodeURIComponent(item.text)}&type=product`;
          return `<a class="search__pill" href="${escapeHtml(href)}">${escapeHtml(item.text)}</a>`;
        })
        .join('');
    };

    const loadTrendingSearches = async () => {
      if (trendingLoaded) {
        sideHeading.textContent = trendingLabel;
        sidePills.innerHTML = trendingPillsHtml;
        return;
      }

      sideHeading.textContent = trendingLabel;
      const letterSeeds = ['a', 'c', 'e', 's', 'b', 'p', 'm', 't'];
      const seedList = (seeds.length ? seeds : letterSeeds).slice(0, 5);
      const seen = new Set();
      const items = [];

      await Promise.all(
        seedList.map(async (seed) => {
          try {
            const url = `${suggestJsonUrl}?q=${encodeURIComponent(seed)}&resources[type]=query&resources[limit]=8&resources[limit_scope]=each`;
            const res = await fetch(url);
            if (!res.ok) return;
            const data = await res.json();
            const queries = data?.resources?.results?.queries || [];
            queries.forEach((query) => {
              const text = (query.text || '').trim();
              const key = text.toLowerCase();
              if (!text || seen.has(key)) return;
              seen.add(key);
              items.push({ text, url: query.url });
            });
          } catch (e) {
            /* keep fallback */
          }
        })
      );

      trendingPillsHtml = renderPills(items.slice(0, 10));
      trendingLoaded = true;
      if (!input.value.trim()) {
        sideHeading.textContent = trendingLabel;
        sidePills.innerHTML = trendingPillsHtml;
      }
    };

    const restoreSidebar = () => {
      sideHeading.textContent = trendingLabel;
      sidePills.innerHTML = trendingPillsHtml || fallbackPills;
    };

    const showDefault = () => {
      if (defaultState) defaultState.hidden = false;
      results.hidden = true;
      results.innerHTML = '';
      restoreSidebar();
    };

    const close = () => search.removeAttribute('open');

    search.querySelectorAll('[data-search-close]').forEach((el) => el.addEventListener('click', close));

    search.addEventListener('toggle', () => {
      if (search.open) {
        positionPanel();
        input.focus();
        loadTrendingSearches();
      } else {
        input.value = '';
        showDefault();
      }
    });

    window.addEventListener('resize', () => {
      if (search.open) positionPanel();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && search.hasAttribute('open')) close();
    });

    input.addEventListener('input', () => {
      const query = input.value.trim();
      clearTimeout(timer);

      if (query.length < 2) {
        showDefault();
        return;
      }

      timer = setTimeout(async () => {
        if (controller) controller.abort();
        controller = new AbortController();

        try {
          const url = `${predictiveUrl}?q=${encodeURIComponent(query)}&section_id=predictive-search&resources[type]=product,query&resources[limit]=12&resources[limit_scope]=each`;
          const response = await fetch(url, { signal: controller.signal });
          if (!response.ok) return;

          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const inner = doc.querySelector('.search__results-inner');
          if (!inner) return;

          const products = inner.querySelector('[data-products-out]');
          results.innerHTML = products ? products.outerHTML : '';

          const suggested = inner.querySelector('[data-side-swap] .search__pills');
          if (suggested && suggested.children.length) {
            sideHeading.textContent = suggestLabel;
            sidePills.innerHTML = suggested.innerHTML;
          } else {
            restoreSidebar();
          }

          if (defaultState) defaultState.hidden = true;
          results.hidden = false;
        } catch (error) {
          /* aborted or network error — keep the current state */
        }
      }, 250);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-affirm"] && !Shopify.designMode) return;
  try {
    (function () {
    function refreshAffirmMessaging() {
      if (window.affirm && affirm.ui && typeof affirm.ui.refresh === 'function') {
        affirm.ui.refresh();
        return true;
      }
      return false;
    }

    function whenAffirmReady(callback) {
      if (window.affirm && affirm.ui && typeof affirm.ui.ready === 'function') {
        affirm.ui.ready(callback);
        return;
      }
      var attempts = 0;
      var timer = setInterval(function () {
        attempts += 1;
        if (window.affirm && affirm.ui && typeof affirm.ui.ready === 'function') {
          clearInterval(timer);
          affirm.ui.ready(callback);
        } else if (refreshAffirmMessaging() || attempts > 40) {
          clearInterval(timer);
        }
      }, 250);
    }

    whenAffirmReady(function () {
      refreshAffirmMessaging();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-availability"] && !Shopify.designMode) return;
  try {
    (function () {
    var STORE_KEY = 'bigerics:store';
    var STORE_NS = 'halifax';
    var STORE_NL = 'st-johns';

    function readStore() {
      try {
        var value = localStorage.getItem(STORE_KEY);
        if (value === STORE_NS || value === STORE_NL) return value;
        return STORE_NS;
      } catch (e) {
        return STORE_NS;
      }
    }

    function stockForHandle(el, handle) {
      if (handle === STORE_NS) return el.dataset.nsInstock === 'true';
      if (handle === STORE_NL) return el.dataset.nlInstock === 'true';
      return false;
    }

    function storeName(el, handle) {
      if (handle === STORE_NS) return el.dataset.storeHalifax || 'Halifax';
      if (handle === STORE_NL) return el.dataset.storeStJohns || "St. John's";
      return handle || '';
    }

    // The locale strings use two different store placeholders: a percent-wrapped
    // one in available_pickup and a brace-wrapped one in availability_store_*.
    // Fill either, and keep the pattern out of Liquid's way.
    function fillStore(tpl, name) {
      return String(tpl || '').replace(/\{\{\s*store\s*\}\}|%store%/g, name);
    }

    function statusRow(host, text, negative) {
      var row = document.createElement('span');
      row.className = negative ? 'p-avail__status is-negative' : 'p-avail__status';

      var tpl = host.querySelector(negative ? '[data-icon-cross]' : '[data-icon-check]');
      if (tpl && tpl.content) {
        row.appendChild(tpl.content.cloneNode(true));
      }

      var label = document.createElement('span');
      label.className = 'p-avail__text';
      label.textContent = text;
      row.appendChild(label);
      return row;
    }

    function replaceStatuses(host, rows) {
      var list = host.querySelector('[data-avail-list]');
      if (!list) return;

      list.replaceChildren();
      rows.forEach(function (row) {
        if (row && row.text) list.appendChild(statusRow(host, row.text, row.negative));
      });
      // Revealed only once populated; the element renders empty server-side.
      host.setAttribute('data-avail-ready', '');
    }

    function setStoreLine(el, handle, statusEl, textEl) {
      var inStock = stockForHandle(el, handle);
      var name = storeName(el, handle);
      var storeTpl = inStock
        ? el.dataset.storeInStock || 'In stock in %store%'
        : el.dataset.storeOutOfStock || 'Out of stock in %store%';

      if (textEl) {
        textEl.textContent = fillStore(storeTpl, name);
      }
      if (statusEl) {
        statusEl.classList.toggle('is-negative', !inStock);
      }
    }

    function orderStoreLines(el, selected) {
      var list = el.querySelector('.p-avail__store-list');
      if (!list) return;

      var items = Array.from(list.querySelectorAll('[data-store-handle]'));
      items.sort(function (a, b) {
        var handleA = a.dataset.storeHandle;
        var handleB = b.dataset.storeHandle;
        var stockA = stockForHandle(el, handleA) ? 1 : 0;
        var stockB = stockForHandle(el, handleB) ? 1 : 0;

        if (stockA !== stockB) return stockB - stockA;
        if (handleA === selected) return -1;
        if (handleB === selected) return 1;
        return 0;
      });

      items.forEach(function (item) {
        list.appendChild(item);
      });
    }

    class ProductAvailability extends HTMLElement {
      connectedCallback() {
        if (!this._bound) {
          this._onStore = function (event) {
            var handle = event && event.detail && event.detail.handle;
            this.refresh(handle);
          }.bind(this);
          document.addEventListener('store:changed', this._onStore);
          window.addEventListener('storage', this._onStore);
          this._bound = true;
        }
        this.refresh();
      }

      disconnectedCallback() {
        if (this._bound) {
          document.removeEventListener('store:changed', this._onStore);
          window.removeEventListener('storage', this._onStore);
          this._bound = false;
        }
      }

      setRowBusy(row, busy) {
        if (!row) return;
        row.classList.toggle('is-busy', busy);
        row.setAttribute('aria-busy', busy ? 'true' : 'false');
      }

      refreshPdp(selected) {
        var online = this.dataset.onlineAvailable === 'true';
        var deliveryRow = this.querySelector('[data-avail-delivery-row]');
        var storeRow = this.querySelector('[data-avail-store-row]');
        var deliveryStatus = this.querySelector('[data-avail-delivery-status]');
        var deliveryText = this.querySelector('[data-avail-delivery-text]');
        var selectedStore = typeof selected === 'string' && selected ? selected : readStore();

        this.setRowBusy(deliveryRow, false);
        this.setRowBusy(storeRow, false);

        if (deliveryText) {
          deliveryText.textContent = online
            ? this.dataset.deliveryAvailable || 'Available for delivery'
            : this.dataset.deliveryUnavailable || 'Unavailable for delivery';
        }
        if (deliveryStatus) {
          deliveryStatus.classList.toggle('is-negative', !online);
        }

        setStoreLine(
          this,
          STORE_NL,
          this.querySelector('[data-avail-store-status-nl]'),
          this.querySelector('[data-avail-store-text-nl]')
        );
        setStoreLine(
          this,
          STORE_NS,
          this.querySelector('[data-avail-store-status-ns]'),
          this.querySelector('[data-avail-store-text-ns]')
        );
        orderStoreLines(this, selectedStore);
      }

      // Grid cards, cart and cart drawer all show delivery AND pickup. The old
      // single line stopped at the first match, so an item that was both in
      // local stock and deliverable advertised only pickup, which shoppers read
      // as "pickup only".
      //
      // Both labels are deliberately store-agnostic. Pickup still reflects the
      // shopper's selected store, so "Pickup in store" means *their* store; the
      // per-store breakdown stays on the product page.
      refreshCompact(selected) {
        var online = this.dataset.onlineAvailable === 'true';
        var inStock = stockForHandle(this, selected);

        // Nothing on offer: one line rather than two negatives.
        if (!online && !inStock) {
          replaceStatuses(this, [
            { text: this.dataset.soldOutLabel || 'Sold out', negative: true },
          ]);
          return;
        }

        replaceStatuses(this, [
          online
            ? { text: this.dataset.onlineLabel || 'Available to ship' }
            : { text: this.dataset.shipUnavailable || 'Not available to ship', negative: true },
          inStock
            ? { text: this.dataset.pickupLabel || 'Available at nearby stores' }
            : { text: this.dataset.pickupUnavailable || 'Not available at nearby stores', negative: true },
        ]);
      }

      refresh(handle) {
        var selected = typeof handle === 'string' && handle ? handle : readStore();
        var mode = this.dataset.mode;

        if (mode === 'pdp') {
          this.refreshPdp(selected);
          return;
        }

        this.refreshCompact(selected);
      }
    }

    if (!customElements.get('product-availability')) {
      customElements.define('product-availability', ProductAvailability);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__pCardQuickAddBound) return;
    window.__pCardQuickAddBound = true;

    var adding = false;

    function quickAddButton(event) {
      var target = event.target;
      if (!target) return null;
      if (target.nodeType !== 1) target = target.parentElement;
      if (!target || typeof target.closest !== 'function') return null;
      return target.closest('[data-quick-add]');
    }

    function cartRoot() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    function addUrl(drawer) {
      if (drawer && drawer.dataset && drawer.dataset.cartAddUrl) {
        return drawer.dataset.cartAddUrl + '.js';
      }
      return cartRoot() + 'cart/add.js';
    }

    function cartJsUrl(drawer) {
      if (drawer && drawer.dataset && drawer.dataset.cartUrl) {
        return drawer.dataset.cartUrl + '.js';
      }
      return cartRoot() + 'cart.js';
    }

    // Capture phase + document delegation so AJAX-injected cards (recs, wishlist) work.
    document.addEventListener(
      'click',
      async function (event) {
        var btn = quickAddButton(event);
        if (!btn) return;

        event.preventDefault();
        event.stopPropagation();

        if (adding || btn.getAttribute('aria-busy') === 'true') return;

        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;

        adding = true;
        btn.setAttribute('aria-busy', 'true');

        var drawer = document.querySelector('cart-drawer');
        var cartPage = document.querySelector('cart-page');
        var wasEmpty =
          typeof window.__getHeaderCartCount === 'function' ? window.__getHeaderCartCount() === 0 : false;
        var sectionIds = [];
        if (drawer && drawer.sectionId) sectionIds.push(drawer.sectionId);
        if (cartPage && cartPage.sectionId) sectionIds.push(cartPage.sectionId);

        var payload = {
          items: [{ id: Number(variantId), quantity: 1 }],
        };
        if (sectionIds.length) payload.sections = sectionIds.join(',');

        try {
          var res = await fetch(addUrl(drawer), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(payload),
          });
          var data = await res.json();

          if (!res.ok) {
            if (drawer && typeof drawer.showError === 'function') {
              drawer.showError(data.description || data.message || 'Could not add to cart.');
              drawer.open();
            }
            return;
          }

          var cart = await (await fetch(cartJsUrl(drawer))).json();

          if (cartPage && data.sections && cartPage.sectionId && data.sections[cartPage.sectionId]) {
            if (typeof cartPage.replaceContents === 'function') {
              cartPage.replaceContents(data.sections[cartPage.sectionId]);
            }
            if (typeof cartPage.updateHeaderCount === 'function') {
              cartPage.updateHeaderCount(cart.item_count);
            }
          }

          if (drawer) {
            if (data.sections && drawer.sectionId && data.sections[drawer.sectionId]) {
              drawer.replaceContents(data.sections[drawer.sectionId]);
            }
          }

          var item =
            typeof window.__cartAddItemFromResponse === 'function'
              ? window.__cartAddItemFromResponse(data)
              : { image: '', title: '', quantity: 1 };

          if (typeof window.__afterCartAdd === 'function') {
            // On the cart page the main section already refreshed — skip drawer/toast.
            window.__afterCartAdd({
              wasEmpty: wasEmpty,
              cart: cart,
              item: item,
              skipFeedback: !!cartPage,
            });
          } else if (typeof window.__updateHeaderCartCount === 'function') {
            window.__updateHeaderCartCount(cart.item_count);
            if (!cartPage && drawer) drawer.open();
          }

          document.dispatchEvent(
            new CustomEvent('cart:refresh', { detail: { item_count: cart.item_count, cart: cart } })
          );
          document.dispatchEvent(
            new CustomEvent('cart:updated', { detail: { item_count: cart.item_count, cart: cart } })
          );
        } catch (e) {
          /* network / parse error — leave the page as-is */
        } finally {
          btn.removeAttribute('aria-busy');
          adding = false;
        }
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-heavy-shipping-notice"] && !Shopify.designMode) return;
  try {
    class HeavyShipDrawer extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;

      this.querySelectorAll('[data-heavy-ship-close]').forEach((el) => {
        el.addEventListener('click', () => this.close());
      });

      document.querySelectorAll('[data-heavy-ship-open]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.open();
        });
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.classList.contains('is-open')) this.close();
      });
    }

    open() {
      this.hidden = false;
      requestAnimationFrame(() => this.classList.add('is-open'));
      document.documentElement.style.overflow = 'hidden';
      const closeBtn = this.querySelector('[data-heavy-ship-close].heavy-ship-drawer__close');
      if (closeBtn) closeBtn.focus();
    }

    close() {
      this.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      setTimeout(() => {
        if (!this.classList.contains('is-open')) this.hidden = true;
      }, 220);
    }
  }

  if (!customElements.get('heavy-ship-drawer')) {
    customElements.define('heavy-ship-drawer', HeavyShipDrawer);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scroll-progress"] && !Shopify.designMode) return;
  try {
    (function () {
    function tracksFor(root) {
      const selector = root.dataset.track || '[data-scroll-track]';
      const parent = root.parentElement;
      if (!parent) return [];
      return Array.from(parent.querySelectorAll(selector));
    }

    function activeTrack(root) {
      const tracks = tracksFor(root);
      return tracks.find((el) => !el.hidden) || tracks[0] || null;
    }

    function update(root) {
      const thumb = root.querySelector('.scroll-progress__thumb');
      const track = activeTrack(root);
      if (!thumb || !track) {
        root.classList.remove('is-visible');
        return;
      }

      const clientWidth = track.clientWidth;
      const scrollWidth = track.scrollWidth;
      const overflow = scrollWidth - clientWidth;
      if (overflow <= 1 || clientWidth <= 0) {
        root.classList.remove('is-visible');
        return;
      }

      root.classList.add('is-visible');
      const barWidth = root.offsetWidth || clientWidth;
      const thumbWidth = (clientWidth / scrollWidth) * barWidth;
      const maxOffset = Math.max(barWidth - thumbWidth, 0);
      thumb.style.width = thumbWidth + 'px';
      thumb.style.transform = 'translateX(' + (track.scrollLeft / overflow) * maxOffset + 'px)';
    }

    function bind(root) {
      if (root.dataset.scrollProgressBound === 'true') return;
      root.dataset.scrollProgressBound = 'true';

      const tracks = tracksFor(root);
      tracks.forEach((track) => {
        track.addEventListener(
          'scroll',
          function () {
            if (track === activeTrack(root)) update(root);
          },
          { passive: true }
        );
      });

      const resizeObserver = new ResizeObserver(function () {
        update(root);
      });
      tracks.forEach((track) => resizeObserver.observe(track));

      const mutationObserver = new MutationObserver(function () {
        update(root);
      });
      tracks.forEach((track) => {
        mutationObserver.observe(track, {
          attributes: true,
          attributeFilter: ['hidden'],
          childList: true,
        });
      });

      window.addEventListener('resize', function () {
        update(root);
      });

      update(root);
    }

    function init(container) {
      const scope = container || document;
      scope.querySelectorAll('[data-scroll-progress]').forEach(bind);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init();
      });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["subscription-quantity-price"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__sealQtyPriceBound) return;
    window.__sealQtyPriceBound = true;

    var WIDGET_SELECTOR = '.sealsubs-target-element';
    var FORM_SELECTOR = 'form[action*="/cart/add"]';

    function settings() {
      var el = document.querySelector('[data-subscription-qty-price]');
      return {
        format: (el && el.dataset.moneyFormat) || '',
        currency: (el && el.dataset.currency) || '',
        note: (el && el.dataset.noteTemplate) || '',
      };
    }

    // Formats cents with the shop's own money format. Brace pairs are built
    // rather than written, since a literal pair here is parsed as Liquid.
    function formatShop(cents, format) {
      var value = Number(cents) || 0;

      function withDelimiters(precision, thousands, decimal) {
        var parts = (value / 100).toFixed(precision).split('.');
        var whole = parts[0].replace(/(\d)(?=(\d{3})+$)/g, '$1' + thousands);
        return parts.length > 1 ? whole + decimal + parts[1] : whole;
      }

      var OPEN = '{' + '{';
      var fallback = '$' + OPEN + 'amount' + '}' + '}';

      return String(format || fallback).replace(
        /\{\{\s*(\w+)\s*\}\}/g,
        function (_m, token) {
          switch (token) {
            case 'amount_no_decimals':
              return withDelimiters(0, ',', '.');
            case 'amount_with_comma_separator':
              return withDelimiters(2, '.', ',');
            case 'amount_no_decimals_with_comma_separator':
              return withDelimiters(0, '.', ',');
            default:
              return withDelimiters(2, ',', '.');
          }
        }
      );
    }

    // The app renders money through `Intl`, which spells the same amount
    // differently from the shop's money format ("CA$38.99" against "$38.99").
    // Both spellings are matched, and a figure is rewritten in whichever one it
    // was found in, so the widget keeps the currency styling it had.
    function locales() {
      var found = [
        document.documentElement.lang,
        window.Shopify && window.Shopify.locale,
        'en',
      ];
      return found.filter(function (value, index) {
        return value && found.indexOf(value) === index;
      });
    }

    function formatIntl(cents, locale, currency) {
      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: currency,
        }).format(Number(cents) / 100);
      } catch (e) {
        return '';
      }
    }

    // A spelling with nothing but digits and separators could match part of an
    // unrelated number, so it is dropped rather than risked.
    function isDistinctive(text) {
      return !!text && /[^\d.,\s]/.test(text);
    }

    function quantity() {
      var form = document.querySelector(FORM_SELECTOR);
      if (!form) return 1;
      var input =
        form.querySelector('[name="quantity"]') ||
        form.querySelector('[data-qty-input]:not([data-extra-qty])');
      var value = input ? parseInt(input.value, 10) : 1;
      return value > 0 ? value : 1;
    }

    // Every amount Shopify published for the variant on show: the one-time
    // price, and each selling plan's price, compare-at and per-delivery price.
    function unitPrices() {
      var host = document.querySelector('[data-pdp-json]');
      if (!host) return [];

      var product;
      try {
        product = JSON.parse(host.textContent);
      } catch (e) {
        return [];
      }

      var variants = (product && product.variants) || [];
      var input = document.querySelector('[data-pdp-variant-id]');
      var id = input ? String(input.value) : '';
      var variant =
        variants.filter(function (candidate) {
          return String(candidate.id) === id;
        })[0] || variants[0];
      if (!variant) return [];

      var cents = [variant.price];
      (variant.selling_plan_allocations || []).forEach(function (allocation) {
        cents.push(
          allocation.price,
          allocation.compare_at_price,
          allocation.per_delivery_price
        );
      });

      return cents.filter(function (value, index) {
        return typeof value === 'number' && value > 0 && cents.indexOf(value) === index;
      });
    }

    // Each way a known price may appear, longest spelling first so a price can
    // never be matched inside a longer one.
    function spellings() {
      var cfg = settings();
      var rows = [];

      unitPrices().forEach(function (cents) {
        var seen = [];

        function add(text, render) {
          if (!isDistinctive(text) || seen.indexOf(text) !== -1) return;
          seen.push(text);
          rows.push({ text: text, cents: cents, render: render });
        }

        add(formatShop(cents, cfg.format), function (total) {
          return formatShop(total, cfg.format);
        });

        if (cfg.currency) {
          locales().forEach(function (locale) {
            add(formatIntl(cents, locale, cfg.currency), function (total) {
              return formatIntl(total, locale, cfg.currency);
            });
          });
        }
      });

      return rows.sort(function (a, b) {
        return b.text.length - a.text.length;
      });
    }

    // Walks text nodes so a price is found by its value, not by a class name
    // the app could rename.
    function textNodesIn(root) {
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      var nodes = [];
      var node;
      while ((node = walker.nextNode())) nodes.push(node);
      return nodes;
    }

    // Returns how many figures were rewritten, so a widget holding none — the
    // app injects an empty one on products with no plans — is left unannotated.
    function scale(element, qty, rows) {
      var rewritten = 0;

      textNodesIn(element).forEach(function (node) {
        // A node still holding what we last wrote is rescaled from the unit
        // price we recorded, so repeated updates never compound. Anything else
        // is a fresh render, and its own text is the unit price.
        var ours = node.__sealWrote === node.nodeValue && node.__sealSource;
        var source = ours ? node.__sealSource : node.nodeValue;
        if (!/\d/.test(source)) return;

        for (var i = 0; i < rows.length; i++) {
          var row = rows[i];
          if (source.indexOf(row.text) === -1) continue;

          var total = row.render(row.cents * qty);
          if (!total) return;

          var next = source.split(row.text).join(total);
          rewritten += 1;
          node.__sealSource = source;
          // Only write on a real change, so the repeat passes below cost
          // nothing and never disturb another app watching these nodes.
          if (node.nodeValue !== next) node.nodeValue = next;
          node.__sealWrote = node.nodeValue;
          return;
        }

        delete node.__sealSource;
        delete node.__sealWrote;
      });

      return rewritten;
    }

    // Says which quantity the figures are for, so a total is never read as the
    // price of one. Sits outside the widget, where the app's re-renders and the
    // walk above both leave it alone.
    function note(element, qty) {
      var cfg = settings();
      var el = element.__sealQtyNote;

      if (qty < 2 || !cfg.note || !element.parentNode) {
        if (el) el.remove();
        return;
      }

      if (!el) {
        el = document.createElement('div');
        el.className = 'seal-qty-note';
        el.__sealOwner = element;
        element.__sealQtyNote = el;
      }
      el.textContent = cfg.note.split('__QTY__').join(String(qty));
      if (!el.isConnected) {
        element.parentNode.insertBefore(el, element.nextSibling);
      }
    }

    // The app nests a target element inside its own wrapper, so only the
    // outermost match is taken — otherwise the same figures are walked twice
    // and the note below is rendered once per nesting level.
    function widgets() {
      var found = Array.prototype.slice.call(
        document.querySelectorAll(WIDGET_SELECTOR)
      );
      return found.filter(function (element) {
        if (!element.isConnected) return false;
        return !found.some(function (other) {
          return other !== element && other.contains(element);
        });
      });
    }

    function applyAll() {
      // A note outlives its widget if the app swaps the whole element out, so
      // orphans are cleared before the surviving widgets are annotated.
      Array.prototype.forEach.call(
        document.querySelectorAll('.seal-qty-note'),
        function (el) {
          if (!el.__sealOwner || !el.__sealOwner.isConnected) el.remove();
        }
      );

      var rows = spellings();
      var qty = quantity();
      widgets().forEach(function (element) {
        // No known prices means no safe rewrite, so the widget is left be.
        var rewritten = rows.length ? scale(element, qty, rows) : 0;
        note(element, rewritten ? qty : 1);
      });
    }

    // The app re-renders asynchronously and in stages, and a currency app
    // rewrites the same nodes afterwards, so one pass on the event is not
    // enough. Watching the widget for mutations instead would fight that other
    // app rewrite for rewrite, so a few fixed passes are used: they settle, and
    // a pass that changes nothing is free.
    var timers = [];
    function schedule() {
      timers.forEach(clearTimeout);
      timers = [0, 200, 600].map(function (delay) {
        return setTimeout(applyAll, delay);
      });
    }

    [
      'sealsubs:price_update',
      'sealsubs:selling_plan_changed',
      'sealsubs:subscription_widget_created',
    ].forEach(function (name) {
      document.addEventListener(name, schedule);
    });

    // Quantity drives the totals; a variant switch changes the prices they are
    // built from, so both re-run the scaling.
    function onFormInput(event) {
      var el = event.target;
      if (!el || typeof el.closest !== 'function') return;

      if (el.closest('.pdp__option-input')) {
        schedule();
        return;
      }
      if (el.hasAttribute && el.hasAttribute('data-extra-qty')) return;
      if (!el.closest('[name="quantity"], [data-qty-input]')) return;
      if (!el.closest(FORM_SELECTOR)) return;
      schedule();
    }

    document.addEventListener('change', onFormInput);
    document.addEventListener('input', onFormInput);

    // The widget is injected after page load, so wait for it rather than
    // assuming it is there.
    function start() {
      schedule();
      if (document.querySelector(WIDGET_SELECTOR)) return;

      var observer = new MutationObserver(function () {
        if (!document.querySelector(WIDGET_SELECTOR)) return;
        observer.disconnect();
        schedule();
      });
      observer.observe(document.body, { childList: true, subtree: true });
      // Stop watching eventually; the widget is not coming.
      setTimeout(function () {
        observer.disconnect();
      }, 15000);
    }

    if (document.readyState !== 'loading') {
      start();
    } else {
      document.addEventListener('DOMContentLoaded', start);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wishlist"] && !Shopify.designMode) return;
  try {
    (function () {
    var KEY = 'bigerics:wishlist';

    function config() {
      var el = document.querySelector('[data-wishlist-i18n]');
      if (!el) return {};
      return {
        add: el.dataset.add || 'Add to wishlist',
        remove: el.dataset.remove || 'Remove from wishlist',
        customerId: el.dataset.customerId || null,
        endpoint: el.dataset.endpoint || '/apps/wishlist',
      };
    }

    var cfg = config();
    var signedIn = !!cfg.customerId;

    // Rendered from this list. Seeded from localStorage so the first paint is
    // instant, then replaced by the server's list once it arrives.
    var list = readLocal();

    function readLocal() {
      try {
        var v = JSON.parse(localStorage.getItem(KEY));
        return Array.isArray(v) ? v.filter(Boolean) : [];
      } catch (e) {
        return [];
      }
    }

    function writeLocal(next) {
      try {
        localStorage.setItem(KEY, JSON.stringify(next));
      } catch (e) {
        /* storage unavailable (private mode) — degrade silently */
      }
    }

    function setList(next) {
      list = Array.isArray(next) ? next.filter(Boolean) : [];
      writeLocal(list);
      document.dispatchEvent(new CustomEvent('wishlist:change'));
    }

    function post(path, body) {
      return fetch(cfg.endpoint + path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body || {}),
      }).then(function (res) {
        if (!res.ok) throw new Error('wishlist request failed: ' + res.status);
        return res.json();
      });
    }

    // Reconcile with the server. Runs once on load for a signed-in customer.
    //
    // Merge is a union and never deletes, so it is safe to run on every load —
    // which also heals a toggle that failed while offline, since that handle is
    // still in the local list and gets pushed up on the next visit.
    function sync() {
      if (!signedIn) return;

      var local = readLocal();
      var request = local.length
        ? post('/merge', { handles: local })
        : fetch(cfg.endpoint, {
            headers: { Accept: 'application/json' },
            // Per-customer data — never serve it from the browser cache.
            cache: 'no-store',
          }).then(
            function (res) {
              if (!res.ok) throw new Error('wishlist load failed: ' + res.status);
              return res.json();
            }
          );

      request
        .then(function (data) {
          if (data && data.signedIn && Array.isArray(data.handles)) {
            setList(data.handles);
          }
        })
        .catch(function () {
          /* Offline or proxy unavailable — keep showing the local list. */
        });
    }

    function reflect() {
      document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
        var handle = btn.dataset.wishlistHandle;
        var on = list.indexOf(handle) !== -1;
        btn.classList.toggle('is-wishlisted', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        btn.setAttribute('aria-label', on ? cfg.remove : cfg.add);
      });
      document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
        el.textContent = list.length;
        el.hidden = list.length === 0;
      });
    }

    function toggle(handle) {
      if (!handle) return false;

      var next = list.slice();
      var i = next.indexOf(handle);
      var adding = i === -1;
      if (adding) {
        next.push(handle);
      } else {
        next.splice(i, 1);
      }

      // Apply immediately; a wishlist tap must never wait on a round trip.
      setList(next);

      if (signedIn) {
        post(adding ? '/add' : '/remove', { handle: handle })
          .then(function (data) {
            // Trust the server's list — it resolves races with another device.
            if (data && data.signedIn && Array.isArray(data.handles)) {
              setList(data.handles);
            }
          })
          .catch(function () {
            /* Keep the optimistic change; the next load's merge pushes it up. */
          });
      }

      return adding;
    }

    window.Wishlist = {
      all: function () {
        return list.slice();
      },
      count: function () {
        return list.length;
      },
      has: function (handle) {
        return list.indexOf(handle) !== -1;
      },
      toggle: toggle,
      remove: function (handle) {
        if (!handle || list.indexOf(handle) === -1) return;
        toggle(handle);
      },
      reflect: reflect,
      sync: sync,
    };

    document.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-wishlist-toggle]');
      if (!btn) return;
      event.preventDefault();
      window.Wishlist.toggle(btn.dataset.wishlistHandle);
    });

    document.addEventListener('wishlist:change', reflect);
    document.addEventListener('shopify:section:load', reflect);
    if (document.readyState !== 'loading') {
      reflect();
    } else {
      document.addEventListener('DOMContentLoaded', reflect);
    }

    sync();
    document.dispatchEvent(new CustomEvent('wishlist:ready'));
  })();
  } catch(e) { console.error(e); }
})();

})();
